import { useQuery } from "@tanstack/react-query";
import { getSupabaseClient } from "../providers/supabase/supabase";

const useDuenoQuery = () =>
  useQuery({
    queryKey: ["is_dueno"],
    queryFn: async () => {
      const { data, error } = await getSupabaseClient().rpc("is_dueno");
      if (error) throw error;
      return !!data;
    },
  });

/** true solo si la base confirma que el usuario es el dueño; mientras carga o si falla, no es dueño. */
export const useIsDueno = () => useDuenoQuery().data === true;

/** Igual que useIsDueno, pero distingue "todavía cargando" para no mostrar avisos de más. */
export const useDuenoStatus = (): "dueno" | "no" | "cargando" => {
  const { data, isPending } = useDuenoQuery();
  if (data === true) return "dueno";
  return isPending ? "cargando" : "no";
};
